export enum ActiveSettingScreenEnum {
    MainMenu = 'MainMenu',
    LoginAndSecurity = 'LoginAndSecurity',
    Privacy = 'Privacy',
    Payments = 'Payments',
    Notifications = 'Notifications',
    Refferal = 'Refferal',
    Preferences = 'Preferences'
    
}